export const FormCheckboxToggle = {
  bindings: {
    form: '<',
    name: '@',
    value: '<',
    onUpdate: '&',
  },

  template: `
    <label class="text-teal border-0 m-0 p-0">
      <input
        class="d-none"
        type="checkbox"
        name="{{ $ctrl.name }}"
        ng-value="$ctrl.value"
        ng-model="$ctrl.form.data[$ctrl.name]"
        ng-click="$ctrl.onUpdate({
          key: $ctrl.name,
          value: !$ctrl.value,
        })"/>
      <i class="fa fa-2x"
        ng-class="{
          'fa-toggle-on': $ctrl.value,
          'fa-toggle-off': !$ctrl.value
        }"></i>
    </label>`,

  controller() {
    return {
      // For some reason ng-value is not updating ng-model when $ctrl.value
      // resolves. $onChanges is essentially doing this manually.
      $onChanges() {
        const field = this.form[this.name];

        if (this.value && field && !field.$viewValue) {
          field.$setViewValue(this.value);
        }
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/FormElements/FormCheckboxToggle.js